<template>
    <div class="relative">
        <!-- trigger -->
        <div @click="isOpen = !isOpen">
            <slot name="trigger" @click="isOpen = !isOpen"></slot>
        </div>

        <button
            v-if="isOpen"
            @click="isOpen = false"
            class="fixed inset-0 h-full w-full cursor-default"
            tabindex="-1"
        ></button>

        <!-- Menus -->
        <div
            v-show="isOpen"
            class="bg-white mt-2 absolute py-2 shadow-lg border whitespace-no-wrap rounded-lg z-20"
            :class="popUp"
            :style="{ width, margin }"
            @click="isOpen = !isOpen"
        >
        
            <slot></slot>
        </div>

    </div>
</template>

<script>

export default {
    props: {
        width: { default: "auto" },
        align: { default: "left" },
        margin: { default: 'auto auto auto auto' },
        top: Boolean,
    },
    data() {
        return {
            isOpen: false,
        };
    },

    computed: {
        popUp() {
            let menu = 'left-0';

            if(this.align != 'left') {
                menu = 'right-0';
            }

            if(this.top) {
                menu += ' bottom-0';
            }
            return menu;
        }
    },

    created() {
        const handleEscape = e => {
            if (e.key === "Esc" || e.key === "Escape") {
                this.isOpen = false;
            }
        };

        document.addEventListener("keydown", handleEscape);
    }
};
</script>